// import { useDispatch } from "react-redux";
import { formatDate } from "../../../../common/Validations";
// import { useNavigate } from "react-router-dom";
// import {addInvoiceID} from "react-router-dom";
// import CustomerConstants from "../../../../common/CustomerConstants";

export let getLedgerColumns = (detailedPageInvoice,tableData) => [
  {
    // name: "CompanyLedgerReport",
    name: "COMPANY_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span className="fw-bold">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <div className="">
            <p className="m-0 p-0 fw-bold">{row.customerName}</p>
            <p className="m-0 p-0">{row.customerCode}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Qty(Sales)",
        cell: (row) => (
          <>
            {row?.transactionType === "PO" ? (
              <div>
                <p className="m-0 p-0 pt-1 text-success fw-bold">--</p>
              </div>
            ) : (
              <div>
                <p className="m-0 p-0 pt-1 text-success fw-bold">
                  {row?.totals?.totalBags}{" "}
                </p>
              </div>
            )}
          </>
        ),
        width: "100px",
      },

      {
        name: "Basic Amount",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-success fw-bold">
                {row?.totals?.totalAmount ?? "--"}
              </span>
            </div>
          </>
        ),
        width: "120px",
      },
      {
        name: "CGST",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-success fw-bold">
                {row?.totals?.totalCgst || "--"}
              </span>
            </div>
          </>
        ),
        width: "120px",
      },
      {
        name: "SGST",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-success fw-bold">
                {row?.totals?.totalSgst ?? "--"}
              </span>
            </div>
          </>
        ),
        width: "120px",
      },
      {
        name: "Debit",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-success fw-bold">
                {row?.totalNetValue || "--"}
              </span>
            </div>
          </>
        ),
        width: "120px",
      },
      {
        name: "Qty(Pur)",
        cell: (row) => (
          <>
            {row?.transactionType === "PO" ? (
              <div>
                <p className="m-0 p-0 pt-1 text-primary fw-bold">
                  {row?.poTotals?.poTotalBags || "--"}{" "}
                </p>
              </div>
            ) : (
              <div>
                <p className="m-0 p-0 pt-1 text-primary fw-bold">--</p>
              </div>
            )}
          </>
        ),
        width: "100px",
      },
      {
        name: "Basic Amount(Pur)",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-primary fw-bold">
                {row?.poTotals?.poTotalAmount ?? "--"}
              </span>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "CGST (Pur)",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-primary fw-bold">
                {row?.poTotals?.poTotalCgst || "--"}
              </span>
            </div>
          </>
        ),
        width: "100px",
      },
      {
        name: "SGST (Pur)",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-primary fw-bold">
                {row?.poTotals?.poTotalSgst ?? "--"}
              </span>
            </div>
          </>
        ),
        width: "100px",
      },
      {
        name: "Credit",
        cell: (row) => (
          <>
            {
              <div
                className="d-flex justify-content-end align-items-center w-100"
                style={{ textAlign: "right" }}
              >
                <span className="text-primary fw-bold">
                  {row?.poTotals?.poTotalNetValue || "--"}
                </span>
              </div>
            }
          </>
        ),
        width: "120px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "CUSTOMER_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span className="fw-bold">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        omit: true,
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span>{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },

      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Qty(Sales)",
        cell: (row) => (
          <>
            {row?.transactionType === "PO" ? (
              <div>
                <p className="m-0 p-0 pt-1 text-success fw-bold">--</p>
              </div>
            ) : (
              <div>
                <p className="m-0 p-0 pt-1 text-success fw-bold">
                  {row?.totals?.totalBags}{" "}
                </p>
              </div>
            )}
          </>
        ),
        width: "100px",
      },

      {
        name: "Debit",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-success fw-bold">
                {row?.totalNetValue || "--"}
              </span>
            </div>
          </>
        ),
        width: "120px",
      },
      {
        name: "Qty(Purchase)",
        cell: (row) => (
          <>
            {row?.transactionType === "PO" ? (
              <div>
                <p className="m-0 p-0 pt-1 text-primary fw-bold">
                  {row?.poTotals?.poTotalBags || "--"}{" "}
                </p>
              </div>
            ) : (
              <div>
                <p className="m-0 p-0 pt-1 text-primary fw-bold">--</p>
              </div>
            )}
          </>
        ),
        width: "120px",
      },
      {
        name: "Credit",
        cell: (row) => (
          <>
            {
              <div
                className="d-flex justify-content-end align-items-center w-100"
                style={{ textAlign: "right" }}
              >
                <span className="text-primary fw-bold">
                  {row?.poTotals?.poTotalNetValue || "--"}
                </span>
              </div>
            }
          </>
        ),
        width: "120px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "MATERIAL_LEDGER",
    columns: [
      {
        name: "Date",
        id: "createdAt",
        selector: (row) => (
          <>
            <span className=" text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        omit: true,
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer ",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span>{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Material",
        id: "materialDescription",
        selector: (row) => row.materialDescription || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">
              {row.materialDescription}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Transaction ",
        // selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
            {/* <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div> */}
          </>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: (
          <div className="text-center w-100">
            <div className="fw-bold text-primary">Inwards</div>
            <div className="d-flex justify-content-around">
              <span className="fw-medium text-primary">Quantity</span>
              <span className="fw-medium text-primary">Value</span>
            </div>
          </div>
        ),
        cell: (row) => (
          <div className="d-flex justify-content-around w-100">
            <div>
              {row.poOrderQuantity ? (
                <>
                  <span className="text-primary fw-bold pe-2">
                    {row.poOrderQuantity}
                  </span>
                  <span className="text-primary fw-bold">{row.uOM}</span>
                </>
              ) : (
                <span className="text-primary fw-bold">--</span>
              )}
            </div>
            <span className="text-primary fw-bold">
              {row.poBasicAmount || "--"}
            </span>
          </div>
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: (
          <div className="text-center w-100">
            <div className="fw-bold text-success">Outwards</div>
            <div className="d-flex justify-content-around">
              <span className="fw-medium text-success">Quantity</span>
              <span className="fw-medium text-success">Value</span>
            </div>
          </div>
        ),
        cell: (row) => (
          <div className="d-flex justify-content-around w-100">
            <div>
              {row.orderQuantityLoad ? (
                <>
                  <span className="text-success fw-bold pe-2">
                    {row.orderQuantityLoad}
                  </span>
                  <span className="text-success fw-bold fw-bold">
                    {row.uOM}
                  </span>
                </>
              ) : (
                <span className="text-success fw-bold fw-bold">--</span>
              )}
            </div>
            <span className="text-success fw-bold">
              {row.basicAmount || "--"}
            </span>
          </div>
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: (
          <div className="text-center w-100">
            <div className="fw-bold text-danger">Closing</div>
            <div className="d-flex justify-content-around">
              <span className="fw-medium text-danger">Quantity</span>
              <span className="fw-medium text-danger">Value</span>
            </div>
          </div>
        ),
        cell: (row, rowIndex) => {
          let closingQuantity = 0;
          let closingValue = 0;

          // Loop from 0 to current row index
          tableData?.slice(0, rowIndex + 1)?.forEach((item) => {
            if (item.transaction === "Purchase") {
              closingQuantity += Number(item.poOrderQuantity || 0);
              closingValue += Number(item.poBasicAmount || 0);
            } else if (item.transaction === "Sales") {
              closingQuantity -= Number(item.orderQuantityLoad || 0);
              closingValue -= Number(item.basicAmount || 0);
            }
          });

          return (
            <div className="d-flex justify-content-around w-100">
              <span className="text-danger fw-bold pe-2">
                {closingQuantity} {row.uOM || "BAGS"}
              </span>
              <span className="text-danger fw-bold pe-2">
                ₹{closingValue.toFixed(2)}
              </span>
            </div>
          );
        },
        sortable: false,
        width: "200px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
      // {
      //   name: (
      //     <div className="text-center w-100">
      //       <div className="fw-bold text-primary">Closing</div>
      //       <div className="d-flex justify-content-around">
      //         <span className="fw-medium text-primary">Quantity</span>
      //         <span className="fw-medium text-primary">Value</span>
      //       </div>
      //     </div>
      //   ),
      //   cell: (row) => (
      //     <div className="d-flex justify-content-around w-100">
      //       <div>
      //         <span className="pe-2">{row.orderQtyLoadConfirm}</span>
      //         <span>{row.uOM}</span>
      //       </div>
      //       <span>{row.value}</span>
      //     </div>
      //   ),
      //   sortable: false,
      //   width: "200px",
      // },
    ],
  },
  {
    name: "CGST_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },

      {
        name: "Debit (Output CGST @ 14% / 9%)",
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {row?.poTotals?.poTotalCgst || "--"}
            </span>
          </div>
        ),
        width: "260px",
      },
      {
        name: "Credit (Output CGST @ 14% / 9%  )",
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.totals?.totalCgst || "--"}
            </span>
          </div>
        ),
        width: "260px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "SGST_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },

      {
        name: "Debit (Output SGST @ 14% / 9%)",
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.poTotals?.poTotalSgst || "--"}
            </span>
          </div>
        ),
        width: "260px",
      },
      // {
      //   name: "Month",
      //   id: "month",
      //   omit: true,
      //   cell: (row) => (
      //     <>
      //       <div>
      //         <p className="m-0 p-0 pt-1 text-danger">{row.totalNetValue} </p>
      //       </div>
      //     </>
      //   ),
      //   width: "140px",
      // },
      {
        name: "Credit (Output SGST @ 14% / 9%)",
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {row?.totals?.totalSgst || "--"}
            </span>
          </div>
        ),
        width: "260px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "ROUNDOFF_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span>{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },

      {
        name: "Debit Round Off",
        cell: (row) => (
          <>
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="text-primary fw-bold">
                {row.poRoundOff ?? "--"}
              </span>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Credit Round off",
        cell: (row) => (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {/* {row.roundOff || "--"} */}
              {row.roundOff ?? "--"}
            </span>
          </div>
        ),
        width: "140px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "INVOICE_REPORT",
    columns: [
      {
        name: "INV Nr",
        selector: (row) => row.invoiceNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.invoiceNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "INV Date",
        selector: (row) => row.invDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.invoiceStatusHeader || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "INV Item Nr",
        selector: (row) => row.invoiceItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " INV Qty ",
        selector: (row) => row.invoiceQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "CompanyLedgerReport",
    // name: "COMPANY_LEDGER",
    columns: [
      {
        name: "Invoice Date",
        selector: (row) => (
          <>
            <span className=" text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span className="text-success">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Qunatity",
        cell: (row) => (
          <div>
            <div>
              <span className="pe-2">{row?.totalBags}</span>
              {/* <span >{row.uOM}</span> */}
            </div>
            {/* <span >{row.value}</span> */}
          </div>
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.unitPrice || "--",
        width: "180px",
      },
      {
        name: "Value",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.totalNetValue} </p>
              {/* <p className="m-0 p-0">{row.shippingPostalCode} </p> */}
            </div>
          </>
        ),
        width: "180px",
      },
      {
        name: "Cgst",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.cgstValue} </p>
              {/* <p className="m-0 p-0 pt-1">{row?.totals.totalCgst} </p> */}
              {/* <p className="m-0 p-0">{row.shippingPostalCode} </p> */}
            </div>
          </>
        ),
        width: "180px",
      },
      {
        name: "Sgst",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.sgstValue} </p>
              {/* <p className="m-0 p-0">{row.shippingPostalCode} </p> */}
            </div>
          </>
        ),
        width: "180px",
      },
      {
        name: "Debit",
        cell: (row) => (
          <>
            <div>
              {/* <p className="m-0 p-0 pt-1">{row.sgstValue} </p> */}
              {/* <p className="m-0 p-0">{row.shippingPostalCode} </p> */}
            </div>
          </>
        ),
        width: "180px",
      },
      {
        name: "Credit",
        cell: (row) => (
          <>
            <div>
              {/* <p className="m-0 p-0 pt-1">{row.sgstValue} </p> */}
              {/* <p className="m-0 p-0">{row.shippingPostalCode} </p> */}
            </div>
          </>
        ),
        width: "180px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },

  {
    name: "SALES_CGST_14_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Debit (Outward  CGST @ 14%)",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-success">
              Debit (Outward CGST @ 14%)
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {row?.totals?.cgstValue_14 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "SALES_SGST_14_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Debit (Outward CGST @ 14%)",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-success">
              Debit (Outward CGST @ 14%)
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {row?.totals?.sgstValue_14 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "SALES_CGST_9_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Output CGST @ 9%",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-success">
              Debit (Output CGST @ 9%)
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {row?.totals?.cgstValue_9 || "--"}
            </span>
          </div>
        ),
        width: "200px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "SALES_SGST_9_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Debit (Outward CGST @ 9%)",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-success">
              Credit (Output CGST @ 14% )
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-success fw-bold">
              {row?.totals?.sgstValue_9 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },

  {
    name: "PURCHASE_CGST_14_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Credit (Output CGST @ 14%  )",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-primary">
              Credit (Output CGST @ 14% )
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.poTotals?.poCgstValue_14 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "PURCHASE_SGST_14_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Credit (Output CGST @ 14%  )",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-primary">
              Credit (Output CGST @ 14% )
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.poTotals?.poSgstValue_14 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "PURCHASE_CGST_9_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Credit (Output CGST @ 9%  )",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-primary">
              Credit (Output CGST @ 9% )
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.poTotals?.poCgstValue_9 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "PURCHASE_SGST_9_LEDGER",

    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "200px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Credit (Output CGST @ 9%  )",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-primary">
              Credit (Output CGST @ 9% )
            </span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.poTotals?.poSgstValue_9 || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
  {
    name: "PURCHASE_IGST_LEDGER",
    columns: [
      {
        name: "Date",
        id: "generatedDate",
        selector: (row) => (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Company",
        id: "companyCodeDesc",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span>{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Customer",
        id: "customerName",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Transaction",
      //   cell: (row) => (
      //     <>
      //       {
      //         <div className="card-body">
      //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
      //             {row?.transaction}{" "}
      //           </span>
      //         </div>
      //       }
      //     </>
      //   ),
      //   width: "160px",
      // },
      {
        name: "Transaction",
        cell: (row) => (
          <>
            {row?.transaction === "Purchase" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div>
            )}
          </>
        ),
        width: "160px",
      },
      {
        name: "Invoice Number",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transaction)
            }
          >
            {row.documentNumber}{" "}
          </button>
        ),
        sortable: true,
        width: "200px",
      },
      // {
      //   name: "Debit (Output CGST @ 14% / 9%)",
      //   cell: (row) => (
      //     <div
      //       className="d-flex justify-content-end align-items-center w-100"
      //       style={{ textAlign: "right" }}
      //     >
      //       <span className="text-primary fw-bold">
      //         {row?.poTotals?.poTotalCgst || "--"}
      //       </span>
      //     </div>
      //   ),
      //   width: "260px",
      // },
      {
        // name: "Credit (Output IGST)",
        name: (
          <div className="text-center w-100">
            <span className="fw-bold text-primary">Credit (Output IGST)</span>
          </div>
        ),
        cell: (row) => (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.poTotals?.poTotalIgst || "--"}
            </span>
          </div>
        ),
        width: "220px",
      },
      {
        name: "Month",
        id: "month",
        omit: true,
      },
    ],
  },
];
